export const DEFAULT_RETARDER_VALUE = 0
